// @ts-nocheck
export const localeCodes =  [
  "en",
  "fr",
  "de",
  "es",
  "pt",
  "it"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_995fa198",
      load: () => import("#nuxt-i18n/995fa198" /* webpackChunkName: "locale_en_46json_995fa198" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_ef37d5e7",
      load: () => import("#nuxt-i18n/ef37d5e7" /* webpackChunkName: "locale_fr_46json_ef37d5e7" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_5f5672fd",
      load: () => import("#nuxt-i18n/5f5672fd" /* webpackChunkName: "locale_de_46json_5f5672fd" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_98313ec2",
      load: () => import("#nuxt-i18n/98313ec2" /* webpackChunkName: "locale_es_46json_98313ec2" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_7bc184eb",
      load: () => import("#nuxt-i18n/7bc184eb" /* webpackChunkName: "locale_pt_46json_7bc184eb" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_b846e21d",
      load: () => import("#nuxt-i18n/b846e21d" /* webpackChunkName: "locale_it_46json_b846e21d" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US"
  },
  {
    code: "fr",
    name: "Français",
    language: "fr-FR",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR"
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de",
    _hreflang: "de",
    _sitemap: "de"
  },
  {
    code: "es",
    name: "Español",
    language: "es-ES",
    _hreflang: "es-ES",
    _sitemap: "es-ES"
  },
  {
    code: "pt",
    name: "Português",
    language: "pt-PT",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT"
  },
  {
    code: "it",
    name: "Italiano",
    language: "it-IT",
    _hreflang: "it-IT",
    _sitemap: "it-IT"
  }
]
/** client **/

/** client-end **/